module.exports = __webpack_public_path__ + "img/record_mode_1.0e0b628a.gif";